import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import noop from 'lodash/noop';
import classnames from 'classnames';
import { Link as SparkLink, LinkStyles } from 'xm-spark';

import {
  cocoonPreventsNavigation,
  getRouterPath,
  goToPlace,
  isLeavingCocoon,
  isToCocoon,
  getPlacePath,
} from 'utils/navigation';

// prevent handler from running if disabled
const getClickDisableHandler =
  (url, onClick) =>
  (e, ...otherArgs) => {
    if (cocoonPreventsNavigation(url)) {
      e.preventDefault();
      return;
    }

    if (onClick) {
      onClick(e, ...otherArgs);
    }
  };

export default function XMLink({
  to,
  className: classNameProp,
  children,
  onClick: onClickProp,
  isNestedGwtLink,
  isHtmlATag,
  ...customProps
}) {
  const onClick = getClickDisableHandler(to, onClickProp);
  const className = classnames(LinkStyles.link, classNameProp);

  if (isHtmlATag || isToCocoon(to) || isLeavingCocoon(to)) {
    return (
      <a
        className={className}
        href={getPlacePath(to)}
        onClick={onClick}
        {...customProps}
      >
        {children}
      </a>
    );
  }

  if (isNestedGwtLink) {
    return (
      <SparkLink
        className={className}
        href={getPlacePath(to)}
        {...customProps}
        onClick={getClickDisableHandler(to, (e, ...otherArgs) => {
          e.preventDefault();
          onClick(e, ...otherArgs);
          goToPlace(to);
        })}
      >
        {children}
      </SparkLink>
    );
  }

  return (
    <Link
      className={className}
      to={getRouterPath(to)}
      onClick={onClick}
      {...customProps}
    >
      {children}
    </Link>
  );
}

XMLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node,
  onClick: PropTypes.func,
  isNestedGwtLink: PropTypes.bool,
};

XMLink.defaultProps = {
  children: '',
  onClick: noop,
  isNestedGwtLink: false,
};

XMLink.displayName = 'XMLink';
